import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { Col, Row } from "react-bootstrap";
import styleButton from "../Button/Button.module.css";
import ModalCustom from "./modal-template-default";
import Button from "../Button";
import useWrapper from "../../hooks/useWrapper";
import { toast } from "react-toastify";
import Loading from "../Loading";
import IcFile from "../Svg/IcFile";

const ModalFilePreview = props => {
  const { file, image, view, closeModal, isWaitingResponse, prefix, ...other } = props;
  const { config } = useWrapper();
  const [fileUrl, setfileUrl] = useState();
  const [isGettingImage, setisGettingImage] = useState();
  useEffect(() => {
    if (!!file) {
      (async () => {
        try {
          setisGettingImage(true);
          const { data: _file } = await api.get(`${prefix}files/${file?.id}/download`, config);
          setfileUrl(_file?.download);
        } catch (__error) {
          console.log("__error", __error);
          toast.error("Erro ao tentar carregar imagem.");
        } finally {
          setisGettingImage(false);
        }
      })();
    }
    // config is recreated every render; effect is intentionally keyed to file/prefix changes only
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file, prefix]);

  return (
    <>
      <ModalCustom {...other} size="lg" show={view} onHide={closeModal} disableClose={!!isWaitingResponse}>
        <>
          <ModalCustom.Header>
            <ModalCustom.Title>{file?.name}</ModalCustom.Title>
          </ModalCustom.Header>
          <ModalCustom.Body>
            {!isGettingImage ? (
              <Row>
                <Col className="text-center">
                  <div className="justify-content-center d-flex">
                    {file?.content_type?.includes("image") ? (
                      <img src={fileUrl} alt="" style={{ maxWidth: "100%" }} />
                    ) : (
                      <IcFile />
                    )}
                  </div>
                  <div className="mt-3">
                    <p className="small-label">{file?.content_type}</p>
                    <p className="small-label mt-0">{file?.size}</p>
                  </div>
                </Col>
              </Row>
            ) : (
              <Loading />
            )}
          </ModalCustom.Body>
          <ModalCustom.Footer>
            <Button disabled={isWaitingResponse} color="primary_ghost" onClick={closeModal}>
              Cancelar
            </Button>
            <a className={`ml-2 ${styleButton.button_primary}`} href={fileUrl} download onClick={closeModal}>
              Download
            </a>
          </ModalCustom.Footer>
        </>
      </ModalCustom>
    </>
  );
};

export default ModalFilePreview;
